import ScenarioType from "./scenarioType";

export default class ScenarioInfo {
  public static getName(scenarioType: ScenarioType): string {
    switch (scenarioType) {
      case ScenarioType.AccordingToPlan:
        return "Everything goes according to plan";
      case ScenarioType.LowerGrowth:
        return "Lower growth";
      case ScenarioType.LiveThreeYearsLonger:
        return "You live longer";
      case ScenarioType.PotsFallTwentyPercent:
        return "Market crash";
      case ScenarioType.NeedExtraMoneyForLastTwoYears:
        return "Need some care";
      default:
        return "Unknown scenario";
    }
  }

  public static getScenarioTypeForServerName(serverName: string): ScenarioType {
    switch (serverName) {
      case "AccordingToPlan":
        return ScenarioType.AccordingToPlan;
      case "LiveLonger":
        return ScenarioType.LiveThreeYearsLonger;
      case "LowerGrowth":
        return ScenarioType.LowerGrowth;
      case "NeedSomeCareInLaterLife":
        return ScenarioType.NeedExtraMoneyForLastTwoYears;
      case "PotFallsInValue":
        return ScenarioType.PotsFallTwentyPercent;
      default:
        throw new Error("Unknown scenario");
    }
  }

  public static getScenarioServerName(scenarioType: ScenarioType) {
    switch (scenarioType) {
      case ScenarioType.AccordingToPlan:
        return "AccordingToPlan";
      case ScenarioType.LiveThreeYearsLonger:
        return "LiveLonger";
      case ScenarioType.LowerGrowth:
        return "LowerGrowth";
      case ScenarioType.NeedExtraMoneyForLastTwoYears:
        return "NeedSomeCareInLaterLife";
      case ScenarioType.PotsFallTwentyPercent:
        return "PotFallsInValue";
      default:
        throw new Error("Unknown scenario");
    }
  }

  public static getScenarioContentKey(scenarioType: ScenarioType) {
    switch (scenarioType) {
      case ScenarioType.AccordingToPlan:
        return "according-to-plan";
      case ScenarioType.LiveThreeYearsLonger:
        return "live-longer";
      case ScenarioType.PotsFallTwentyPercent:
        return "market-crash";
      case ScenarioType.NeedExtraMoneyForLastTwoYears:
        return "need-care";
      case ScenarioType.LowerGrowth:
        return "lower-growth";
      default:
        throw Error("Unknown scenario");
    }
  }
}
